/** Time display update interval ID */
let timeIntervalId: number | null = null;

/**
 * Update the time display
 */
function updateTimeDisplay(): void {
  const now = new Date();

  const timeStr = now.toLocaleTimeString('en-US', { hour12: false });
  const dateStr = now
    .toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    })
    .toUpperCase();

  const timeElement = document.getElementById('current-time');
  const dateElement = document.getElementById('current-date');

  if (timeElement) {
    timeElement.textContent = timeStr;
  }
  if (dateElement) {
    dateElement.textContent = dateStr;
  }
}

/**
 * Initialize time display with auto-update
 */
export function initTimeDisplay(): void {
  // Update immediately
  updateTimeDisplay();

  // Update every second
  if (timeIntervalId === null) {
    timeIntervalId = window.setInterval(updateTimeDisplay, 1000);
  }
}

/**
 * Stop time display updates
 */
export function stopTimeDisplay(): void {
  if (timeIntervalId !== null) {
    clearInterval(timeIntervalId);
    timeIntervalId = null;
  }
}
